import React from "react";
import { Row, Col } from 'react-bootstrap'
import Carousel from 'nuka-carousel';
import ScrollAnimation from 'react-animate-on-scroll';

class Category extends React.Component {
	
	render() {
      
		return (



        <div className="category">
         <div className="category-header">
        <h3> Your Top Categories </h3>
        <p>Choose Between Different Categories </p>
        </div>
                <div className="container">

       
        
        <Row>
        <ScrollAnimation animateIn="fadeIn"
                >
<Col md={2} Col xs={6} className="custom-width">
        <div className="category-item">
        <div className="category-item-holder">

         <a href ="/shop"> <img src={require("../../img/Home/jeans.png")}/> </a>
        </div>
       <a href ="/shop"> <h3> Jeans </h3> </a>
        </div>
         </Col>
         </ScrollAnimation>

        <ScrollAnimation animateIn="fadeIn"
                >

        <Col md={2} Col xs={6} className="custom-width">
        <div className="category-item">
        <div className="category-item-holder">

                <a href ="/shop"> <img src={require("../../img/Home/tshirt.png")}/> </a>
        </div>
        <a href ="/shop">  <h3> Shirts </h3></a>
        </div>
         </Col>
         </ScrollAnimation>

        <ScrollAnimation animateIn="fadeIn"
                >

        <Col md={2} Col xs={6} className="custom-width">
        <div className="category-item">
        <div className="category-item-holder">

               <a href ="/shop">  <img src={require("../../img/Home/shose.png")}/></a>
        </div>
        <a href ="/shop"> <h3> Shoes </h3> </a>
        </div>
         </Col>
         </ScrollAnimation>

        <ScrollAnimation animateIn="fadeIn"
                >

        <Col md={2} Col xs={6} className="custom-width">
        <div className="category-item">
        <div className="category-item-holder">

               <a href ="/shop">  <img src={require("../../img/Home/perfum.png")}/></a>
        </div>
        <a href ="/shop"> <h3>Perfumes</h3> </a>
        </div>
         </Col>
         </ScrollAnimation>

        <ScrollAnimation animateIn="fadeIn"
                >

        <Col md={2} Col xs={6} className="custom-width">
        <div className="category-item">
        <div className="category-item-holder">

    <a href ="/shop"> <img src={require("../../img/Home/short.png")}/></a>
        </div>
        <a href ="/shop"> <h3>Shorts </h3> </a>
        </div>
         </Col>
         </ScrollAnimation>


        </Row>

     <Carousel>
         <div className="newlook">
         <div className="newlook__share share">
         <a href="#"><i class="fa fa-share-alt" aria-hidden="true"></i></a>

         </div>

             <h3 className="newlook-caption"> New Lock</h3>
             <p> Show new Fashion Classic collection</p>
     <img src={require("../../img/Home/newlook.png")}/>
     </div>
     <div className="newlook">
             <h3 className="newlook-caption"> New Lock</h3>
             <p> Show new Fashion Classic collection</p>
     <img src={require("../../img/Home/newlook.png")}/>
     </div>
     

      </Carousel>   

    

      </div>
        </div>

       );
    }
  }
  
  export default Category;
  


// WEBPACK FOOTER //
// ./src/Components/Category/Category.jsx